<!--
 * @Descripttion: 
 * @Author: 苍狼一啸八荒惊
 * @Date: 2024-08-29 17:04:14
 * @LastEditTime: 2025-09-11 13:49:01
 * @LastEditors: sudo_rm_rf
-->
<template>
  <a-config-provider
    :locale="locale == 'zh_CN' ? zhCN : enUS"
    :theme="{
      token: {
        colorPrimary: nowCustomColor ? nowCustomColor : nowTheme === 'dark' ? '#646cff' : '#00A9BB',
      },
      algorithm: nowTheme === 'dark' ? anttheme.darkAlgorithm : anttheme.defaultAlgorithm,
    }"
  >
    <!-- <scale-screen
      width="1920"
      height="1080"
      :delay="500"
      :fullScreen="false"
      :boxStyle="{
        background: '#E5E6E8',
        overflow: isScale ? 'hidden' : 'auto',
      }"
      :wrapperStyle="wrapperStyle"
      :autoScale="isScale"
    > -->
    <!-- <div class="content_wrap"> -->
      <router-view v-slot="{ Component, route }" :key="$route.fullPath">
        <keep-alive v-if="$route.meta.keepAlive">
          <component :is="Component" :key="$route.path" />
        </keep-alive>
        <component :is="Component" v-else :key="$route.path" />
      </router-view>
    <!-- </div> -->
    <!-- </scale-screen> -->
  </a-config-provider>
  <!-- <div v-if="useUser().roles.length > 0">
    <WebSocket />
  </div> -->
</template>

<script lang="ts" setup>
defineOptions({ name: 'App' });
import WebSocket from '/@/components/WebSocket/index.vue';
import { theme as anttheme } from 'ant-design-vue';
import { setCookie, getCookie } from '/@/utils/cookie';
import ScaleScreen from '/@/components/scaleScreen/index.vue';

import { useSettingStore, useUser } from '/@/store';
const settingStore = useSettingStore();
// settingStore.$subscribe((mutation, state) => {
//   console.log(mutation, state);
// });
// console.log(settingStore.$state);
const { isScale } = storeToRefs(settingStore);
const wrapperStyle = {};

import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

import { useI18n } from 'vue-i18n';
const i18n = useI18n({ useScope: 'global' });

import useCommonStore from '/@/store/modules/common';
import { storeToRefs } from 'pinia';
let pinia = useCommonStore();
let { locale, theme, customColor } = storeToRefs(pinia);

onMounted(() => {});

// 下面这样写，多写个watch监听和storage监听，是为了兼容多窗口切换主题，一点都不多余
const nowTheme = ref(theme.value);
const nowCustomColor = ref(customColor.value);
// 监听当前窗口的主题变化
watch(theme, (val) => {
  nowTheme.value = val;
});
watch(customColor, (val) => {
  nowCustomColor.value = val;
});
// 多窗口监听 监听storage 改变其他窗口主题，语言变化
window.addEventListener('storage', function (e) {
  console.log('e.key ', e.key);
  if (e.key === 'common') {
    let storage = JSON.parse(e.newValue || '{}');
    nowTheme.value = storage.theme;
    console.log('storage', storage);
    init(storage.theme, storage.locale);
    pinia.changeTheme(storage.theme);
    pinia.changeLocal(storage.locale);
    pinia.changeCustomColor(storage.customColor);
  }
});
const changeElementClass = (isDark: boolean) => {
  if (isDark) {
    document.documentElement.removeAttribute('class');
    document.documentElement.setAttribute('class', 'dark');
  } else {
    document.documentElement.removeAttribute('class');
    document.documentElement.setAttribute('class', 'light');
  }
};
const init = (theme: string, locale: string) => {
  // theme
  document.documentElement.setAttribute('style', `color-scheme: ${theme}`);
  changeElementClass(theme == 'dark');
  // locale
  i18n.locale.value = locale;
};
init(pinia.$state.theme, pinia.$state.locale);
</script>

<style lang="less" scoped>
.content_wrap {
  width: 100vw;
  height: 100vh;
  // height: 100vh;
  // padding: 10px;
  box-sizing: border-box;
  background-color: white;
  // outline: dashed 1px blue;
  // background-image: url('/@/assets/imgs/login-background.jpg');
  // background-size: cover;
  // background-position: center center;
}
</style>
